export const splitSizes = item => item.stockPorParte ? String(item.talleProd || '').split('/') : [];
export const sizeLabel = item => item.talleTop && item.talleBottom ? `Top ${item.talleTop} · Bottom ${item.talleBottom}`
  : item.stockPorParte && splitSizes(item).length === 2 ? `Top ${splitSizes(item)[0]} · Bottom ${splitSizes(item)[1]}` : item.talleProd;
export const sameVariant = (a, b) => a.id === b.id && a.colorProd === b.colorProd && a.talleProd === b.talleProd;
export function availableStock(product, items = []) {
  const color = product.colores?.find(color => color.color === product.colorProd);
  if (product.stockPorParte) {
    const sizes = splitSizes(product);
    if (sizes.length !== 2 || sizes.some(size => !size)) return 0;
    return Math.max(0, Math.min(...['top','bottom'].map((part,index) => {
      const stock = Number(color?.[part]?.find(size => size.talle === sizes[index])?.stock) || 0;
      const used = items.filter(item => item.id === product.id && item.colorProd === product.colorProd && item.stockPorParte && !sameVariant(item,product) && splitSizes(item)[index] === sizes[index])
        .reduce((total,item) => total + item.cantidad,0);
      return stock - used;
    })));
  }
  return Math.max(0, Number(color?.talles?.find(talle => talle.talle === product.talleProd)?.stock) || 0);
}
export function addProduct(items, product) {
  const quantity = Math.max(1, Math.floor(Number(product.cantidad) || 1));
  const existing = items.find(item => sameVariant(item, product));
  const cantidad = Math.min((existing?.cantidad || 0) + quantity, availableStock(product,items));
  if (cantidad === 0) return items;
  return existing ? items.map(item => sameVariant(item, product) ? { ...item, cantidad } : item) : [...items, { ...product, cantidad }];
}
export function changeQuantity(items, variant, delta) {
  return items.map(item => sameVariant(item, variant) ? { ...item, cantidad: Math.min(availableStock(item,items), Math.max(0,item.cantidad + delta)) } : item).filter(item => item.cantidad > 0);
}
export function cartTotals(items) {
  return items.reduce((totals,item) => ({totalItems:totals.totalItems+item.cantidad,precioTotal:Math.round((totals.precioTotal+Number(item.precioProd)*item.cantidad)*100)/100}),{totalItems:0,precioTotal:0});
}
